export const STORE_BOOKING_ON_GOOGLE = 'bookingOnGoogleStore';
export const BOG_SET_OPTIONS = 'setOptions';
export const BOG_SET_FILTERS = 'setFilters';
export const BOG_FETCH_DATA = 'fetchData';
export const BOG_FETCH_HOLIDAYS = 'getHolidays';
export const BOG_CHANGE_OTA_POSITIONS = 'changeOtaPositions';

export const BOG_MAX_GUEST_COUNT = 4;
export const BOG_MAX_NIGHT_COUNT = 2;
